import { Flex, Text } from '@approvalmax/ui/src/components';
import ImageSleep from 'modules/components/ImageIcons/ImageSleep';
import { memo } from 'react';

import { messages } from './EmptyVersionHistoryList.messages';

export const EmptyVersionHistoryList = memo(() => (
    <Flex direction='column' justifyContent='center' alignItems='center' height='100%'>
        <ImageSleep />

        <Text font='body' fontSize='large'>
            {messages.emptyListText}
        </Text>
    </Flex>
));

EmptyVersionHistoryList.displayName = 'EmptyVersionHistoryList';
